import type { Props } from './Svg'
import { Svg } from './Svg'

export function PowerIcon(props: Props) {
  return (
    <Svg width="20" height="20" fill="currentColor" stroke="none" {...props}>
      <path d="M10 20A10 10 0 0 1 5.6 1a1 1 0 1 1 .8 2A8 8 0 0 0 2 10a8 8 0 1 0 11.6-7.2 1 1 0 0 1 .8-1.7A9.9 9.9 0 0 1 20 10a10 10 0 0 1-10 10Z" />
      <path d="M10 11a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v9a1 1 0 0 1-1 1Z" />
    </Svg>
  )
}
